import React, { useContext } from "react";
import ExploreCard from "./ExploreCard";
import "../styles/ExploreSection.css";
import rescue from "../assets/Rescue.png";
import adopt from "../assets/Adopting.png";
import lost from "../assets/Found.png";
import dogBoneGray from "../assets/dog bone gray.png";
import exploreImage from "../assets/explore.png";
import pawImage from "../assets/paws.png";
import pawLine from "../assets/bones line.png";
import { LanguageContext } from "../LanguageContext"; // Import the context

const ExploreSection = () => {
  const { language } = useContext(LanguageContext); // Use the context

  // Text content for English and Arabic
  const text = {
    en: {
      exploreTitle: "Explore",
      exploreItems: [
        {
          title: "Rescue and be a hero!",
          description:
            "Connect with local rescues to help pets in need find safe, loving homes.",
          icon: rescue,
        },
        {
          title: "Adopt a new bestie!",
          description:
            "Dive into a world of adorable pets ready to snuggle up and fill your life with love.",
          icon: adopt,
        },
        {
          title: "Never lost, always found.",
          description:
            "Misplaced a precious pet? Our lost & found section is here to reunite you with your beloved companions.",
          icon: lost,
        },
      ],
    },
    ar: {
      exploreTitle: "اكتشف",
      exploreItems: [
        {
          title: "أنقذ وكن بطلًا!",
          description:
            "تواصل مع فرق الإنقاذ المحلية لمساعدة الحيوانات الأليفة المحتاجة في العثور على منازل آمنة ومليئة بالحب.",
          icon: rescue,
        },
        {
          title: "تبنى صديقًا جديدًا!",
          description:
            "اغوص في عالم من الحيوانات الأليفة الجميلة الجاهزة للعناق وملء حياتك بالحب.",
          icon: adopt,
        },
        {
          title: "لا تفقد أبدًا، دائمًا ما تجد.",
          description:
            "هل فقدت حيوانك الأليف الثمين؟ قسم الفقد والوجدان هنا ليعيدك مع أحبائك.",
          icon: lost,
        },
      ],
    },
  };

  // Fallback to English if language is invalid
  const currentText = text[language] || text.en;

  return (
    <>
      <section className="explore-section">
        <div className="explore-header">
          <h2>{currentText.exploreTitle}</h2> {/* Dynamic title */}
        </div>
        <div className="explore-content">
          <div className="dog-bone-icon">
            <img src={dogBoneGray} alt="Dog bone icon" />
          </div>
          <div className="explore-image">
            <div className="paw-prints">
              <img src={pawImage} alt="Paw prints" />
            </div>
            <div className="rotated-frame">
              <img src={exploreImage} alt="Rescue animal" />
            </div>
          </div>
          <div className="explore-cards">
            {currentText.exploreItems.map((item, index) => (
              <ExploreCard
                key={index}
                icon={item.icon}
                title={item.title}
                description={item.description}
              />
            ))}
          </div>
        </div>
      </section>
      <img src={pawLine} alt="" className="w-100" />
    </>
  );
};

export default ExploreSection;
